export var getUserInitials = function getUserInitials(user) {
  var _user$first_name, _user$last_name;
  if (!user || !user.first_name || !user.last_name) {
    return '';
  }
  return "".concat((_user$first_name = user.first_name) == null ? void 0 : _user$first_name.charAt(0)).concat((_user$last_name = user.last_name) == null ? void 0 : _user$last_name.charAt(0)).toUpperCase();
};